import partnerEdition from "assets/data/glampartnerEdition.json";
import React, {Component} from "react";
import Helmet from "react-helmet";
import Styles from "views/pages/MelhoreSeusPosts.module.scss";
import FavPost from "assets/img/melhores-posts/fav-posts.png"
import AdvGlambox from "assets/img/melhores-posts/glambox-adv.png"
import AdvGlamshop from "assets/img/melhores-posts/glamshop-adv.png"
import PostTips from "assets/img/melhores-posts/post-tips.png"

class MelhoreSeusPosts extends Component {
  renderCarreira = () => {
    return (
      <>
        <div
          className={"level-2 p-3 p-xl-5 " + Styles["dicas"]}
          style={{background: "#fff", marginBottom: "30px"}}>
          <h1>Melhores Posts</h1>
          <h3>Aqui você encontra materiais e dicas que vão te ajudar a divulgar melhor o universo Glam e seus
            benefícios</h3>
          <div className={Styles["topics-box"]}>
            <a href={"https://drive.google.com/drive/u/0/folders/1-U49jUGhxnLdySDuhkitJ3mM1uR0w9B6"}
               target={"_blank"}
               className={Styles["item"]}>
              <div className={Styles["top"]}>
                <div className={Styles["icon"]}>
                  <img src={AdvGlambox} alt=""/>
                </div>
                <div className={Styles["title"]}>
                  Divulgue Assinaturas
                </div>
                <div className={Styles["text"]}>
                  Aqui você encontra vídeos e imagens da edição atual da box.
                  Mesmo que sua caixinha ainda não tenha chego, você já pode divulgar a edição com seu cupom.
                </div>
              </div>
              <div className={Styles["see-more"]}>
                Saiba Mais
              </div>
            </a>
            <a href={"https://drive.google.com/drive/u/0/folders/1Orj2gTxCeXywOIz62JQsx2sYrtJiN0iC"}
               target={"_blank"}
               className={Styles["item"]}>
              <div className={Styles["top"]}>
                <div className={Styles["icon"]}>
                  <img src={AdvGlamshop} alt=""/>
                </div>
                <div className={Styles["title"]}>
                  Divulgue Produtos
                </div>
                <div className={Styles["text"]}>
                  Disponibilizamos materiais que te ajudam a divulgar seu cupom de desconto para os produtos da Glamshop.
                </div>
              </div>
              <div className={Styles["see-more"]}>
                Saiba Mais
              </div>
            </a>
            <a href={"https://drive.google.com/drive/u/0/folders/1RMup-U6dXedjj6ZPH8Y6EIvFwnUH1SjT"}
               target={"_blank"}
               className={Styles["item"]}>
              <div className={Styles["top"]}>
                <div className={Styles["icon"]}>
                  <img src={PostTips} alt=""/>
                </div>
                <div className={Styles["title"]}>
                  Dicas para posts incríveis
                </div>
                <div className={Styles["text"]}>
                  Está com dúvidas de como fazer sua unboxing perfeita? Está num dilema criativo?
                  Aqui temos várias dicas que podem te ajudar!
                </div>
              </div>
              <div className={Styles["see-more"]}>
                Saiba Mais
              </div>
            </a>
            <a
              href={"https://drive.google.com/drive/u/0/folders/1hYXU-VDWygvsTW9gAwGKhW7oSXSIZIDi"}
              target={"blank"}
              className={Styles["item"]}>
              <div className={Styles["top"]}>
                <div className={Styles["icon"]}>
                  <img src={FavPost} alt=""/>
                </div>
                <div className={Styles["title"]}>
                  Alguns dos nossos posts favoritos
                </div>
                <div className={Styles["text"]}>
                  Nossas influencers sempre nos surpreendem! Aqui montamos uma seleção de posts que viraram nossos queridinhos. Esperamos que te inspirem!
                </div>
              </div>
              <div className={Styles["see-more"]}>
                Saiba Mais
              </div>
            </a>
          </div>

          {/* MATERIAL P/ DIVULGAÇÃO */}
          {/*this.renderMateriaisDivulgacao()*/}

        </div>

      </>

    );
  };

  renderMateriaisDivulgacao = () => {
    return (
      <>

        {/* EDIÇÃO ATUAL + IMAGENS */}
        <h2>{partnerEdition.titulo}</h2>
        <div className={"level-2 gp_alert"}>
          <p>
            Suas seguidoras irão receber essa edição assinando do dia{" "}
            <strong>{partnerEdition.datas}.</strong>
          </p>
        </div>
        <div className={"edition_divulgacao"}>
          <p>
            <strong>{partnerEdition.hashtag}</strong> - {partnerEdition.texto}
          </p>
          <div className={"images_edition"}>
            {this._renderEditionImagesList()}
          </div>
        </div>
        <div>
          <br/>
        </div>
      </>
    );
  }

  _renderEditionImagesList = () => {
    return partnerEdition.imagens.map((item, key) => {
      return (
        <div key={key} className={"cover"}>
          <img
            src={
              "https://s3.amazonaws.com/Glambox.Content.MediaObject/" +
              item.imagem
            }
            alt={""}
          />
          <p className={"text-center"}>
            <a
              href={
                "https://s3.amazonaws.com/Glambox.Content.MediaObject/" +
                item.imagem
              }
              className={"btn btn-sm btn-light-pink m-auto"}
              target="_blank"
              download={true}
            >
              Baixar imagem
            </a>
          </p>
        </div>
      );
    });
  };


  render() {
    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Portal Glampartners : Melhore seus Posts</title>
        </Helmet>

        {this.renderCarreira()}

      </div>
    );
  }

}

export {
  MelhoreSeusPosts
};

